import { TableHeadersType } from "../tableHeadersType";

export const AUDIT_SESSION_HEADERS: TableHeadersType[] = [
  {
    label: "Start Date",
    value: "start_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "End Date",
    value: "end_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Financial Year",
    value: "financial_year",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Audit Team",
    value: "user_details",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ADDED/MODIFIED BY",
    value: "updated_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Action",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];
export const auditSessionFinancialDropdown=[
    {
        value: "",
        label: "Select..",
      },
      {
        value: "2024-25",
        label: "2024-25",
      },
      {
        value: "2023-24",
        label: "2023-24",
      },
      {
        value: "2022-23",
        label: "2022-23",
      },
    
]
